import { safeStorage } from '@/lib/storage'

/**
 * S-D2 screen 03's **Keep me signed in**, remembered per browser (AUTH-5).
 *
 * The choice belongs to the device, not to the account: a person who unticks it
 * on a shared machine in a cyber café has said something about *that machine*,
 * and it must not follow them to their own laptop. `localStorage` is exactly
 * that scope, and it is the only store here that is.
 *
 * **The value is a preference, never a credential.** It says which cookie
 * lifetime to ask for; the session itself lives in an `HttpOnly` cookie this
 * code cannot read and a row the server owns. Somebody with access to the
 * browser's storage learns that a box was ticked, which they could also learn
 * by looking at the box.
 *
 * Read back by the session-expiry dialog, which re-authenticates without
 * showing the checkbox: without this it would have to guess, and both guesses
 * are wrong — assuming *persistent* silently overrides a deliberate "not on
 * this machine", and assuming *not* logs a working user out every time they
 * close the browser after one re-auth.
 *
 * Defaults to `true` when nothing is stored, which is the box's own default
 * state and the behaviour every session had before the box existed.
 */
const KEY = 'augrank.keep-signed-in'

export function keepSignedIn(): boolean {
  return safeStorage().getItem(KEY) !== 'false'
}

export function rememberKeepSignedIn(value: boolean): void {
  safeStorage().setItem(KEY, value ? 'true' : 'false')
}
